import React from 'react'
import {motion} from 'framer-motion'
import SafeIcon from '../../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'

const {FiThumbsUp, FiMessageSquare, FiFileText, FiList, FiSearch} = FiIcons

const ProgressBar = ({progress, currentStep, variant = 'broad'}) => {
  const steps = [
    'Finding niche collaborations...',
    'Searching blog comments...',
    'Finding guest post opportunities...',
    'Scanning forums...',
    'Locating resource pages...'
  ]

  // Icons for each step
  const stepIcons = [
    FiThumbsUp,
    FiMessageSquare,
    FiFileText,
    FiMessageSquare,
    FiList
  ]

  // Step labels without the ellipsis
  const stepLabels = [
    'Niche Collaborations',
    'Blog Comments',
    'Guest Posts',
    'Forum Comments',
    'Resource Pages'
  ]

  
  return (
    <div className="bg-white rounded-2xl shadow-lg p-8">
      <div className="text-center mb-8">
        <h3 className="text-2xl font-bold text-gray-900 mb-2">
          Searching for Backlinks
        </h3>
        <p className="text-gray-600">
          {steps[Math.floor((progress / 100) * steps.length)] || 'Initializing...'}
        </p>
      </div>

      {/* Animated Dog Logo */}
      <div className="flex flex-col items-center justify-center mb-36">
        
        <p className="text-lg font-medium text-[#D59A4C] font-chewy">
          Fetching your links now
        </p>
      </div>

      <div className="relative">
        <motion.div
          className="absolute"
          style={{bottom: '100%'}}
          initial={{left: 0}}
          animate={{left: `${progress}%`}}
          transition={{duration: 0.5, ease: 'easeOut'}}
        >
          <img 
            src="https://k9links.com/wp-content/uploads/2025/08/K9-Links-Sniffing-Link-for-Progress-Loader.webp" 
            alt="K9 Links Logo" 
            className="w-32 h-32 object-contain transform -translate-x-1/2" 
          />
        </motion.div>
        <div className="w-full bg-gray-200 rounded-full h-3">
          <motion.div 
            className="bg-[#D59A4C] h-3 rounded-full" 
            initial={{width: 0}} 
            animate={{width: `${progress}%`}} 
            transition={{duration: 0.5}} 
          />
        </div>
        <div className="text-center mt-4">
          <span className="text-lg font-semibold text-gray-900">
            {Math.round(progress)}%
          </span>
        </div>
      </div>

      {/* Updated to conditional layout */}
      {variant === 'custom' ? (
        <div className="mt-8 grid grid-cols-1 gap-2">
          <div className={`text-center p-2 rounded-lg text-xs ${progress > 0 ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-600'}`}>
            <div className="flex items-center justify-center mb-1">
              <SafeIcon icon={FiSearch} className="w-4 h-4 mr-1" />
              <span className="font-bold text-[14px]">Custom Search Footprint</span>
            </div>
          </div>
        </div>
      ) : (
        <div className="mt-8 grid grid-cols-5 gap-2">
          {stepLabels.map((step, index) => (
            <div 
              key={index} 
              className={`text-center p-2 rounded-lg text-xs ${progress > (index / steps.length) * 100 ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-600'}`}
            >
              <div className="flex items-center justify-center mb-1">
                <SafeIcon 
                  icon={stepIcons[index]} 
                  className="w-4 h-4 mr-1" 
                />
                <span className="font-bold text-[14px]">{step}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default ProgressBar
